import http from '../../http-common'

class SchoolService {
  getSchoolList() {
    return http.get('/school/options')
    .catch((error) => console.log(error.message));
  }
}

export default new SchoolService()
